/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SubPage, PopupMessage } from '@insticator/insticator-ui'; // iui-material
import NoRequest from 'pages/dashboard/ratings/requestratingwidget/requeststatus/norequest';
import RequestReceived from 'pages/dashboard/ratings/requestratingwidget/requeststatus/requestreceived';
// utils
import { url } from 'utils/urls';
// pages

// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/requestratingwidget/requestratingwidget_styles';


/* ========== ~~~~~~~~~~ REQUEST RATINGS WIDGET ~~~~~~~~~~ ========== */
const RequestRatingWidget = (props) => {
    const sendRequestForWidget = () => {
        if (props.mocked) {
           return props.displayModal(true, <PopupMessage
                type={'approve'}
                title={'Are you sure you want to automatically approve rating for this publisher?'}
                body={<p><br/></p>}
                buttonPrimary={{ text: 'Approve', variant: 'action', action: () => props.requestRatingWidget(props.accountUUID) && props.displayModal(false)}}
                buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => props.displayModal(false) }}
            />);
        }
        return props.requestRatingWidget(props.accountUUID);
    };
    const renderCopy = () => !props.requestSent ?
        <NoRequest buttonDisabled={props.status !== null} requestPending={props.requestPending} sendRequest={sendRequestForWidget}/> : <RequestReceived email={props.emailSentTo} />;
    return(
        <SubPage klass={`requestratingwidget ${props.classes.requestratingwidget} disabled-${props.approving}`} name={`requestratingwidget`}>
            {renderCopy()}
            <div className={'graphic'}>
                <img src={`${url.image}/illustrations/illustration-ratings-feature.png`} />
            </div>
        </SubPage>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RequestRatingWidget);
